import { render } from "./Carousel.vue?vue&type=template&id=2a1bf8eb&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=2a1bf8eb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a1bf8eb"

export default script